<template>
    <multiselect
            :clear-on-select="false"
            :close-on-select="true"
            :hide-selected="true"
            :internal-search="false"
            :limit="3"
            :loading="isLoading"
            :max-height="600"
            :options="currencies"
            :options-limit="300"
            :searchable="true"
            :show-no-results="false"
            @search-change="getCurrencies"
            @input="onSelect()"
            id="currency"
            label="name"
            name="currencyid"
            open-direction="bottom"
            placeholder="Search currency"
            track-by="id"
            v-model="currency">
        <template slot="singleLabel" slot-scope="props">
            {{props.option.symbol}} - {{props.option.name}}
        </template>
        <template slot="option" slot-scope="props">
            <div class="option__desc">
                <p>{{ props.option.symbol }}</p>
                <h5>{{ props.option.name }}</h5>
            </div>
        </template>
        <span slot="noResult">Currency not found</span>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "CurrencySelect",
        props: {},
        components: {Multiselect},
        data() {
            return {
                isLoading: false,
                currency: null,
                currencies: []
            }
        },
        methods: {
            async getCurrencies(searchText) {
                this.isLoading  = true;
                let row         = await this.$http.get('currency/search', {
                    params: {
                        search: searchText
                    }
                });
                this.currencies = row.data;
                this.isLoading  = false;
            },
            onSelect() {
                this.$emit('currency-select', this.currency);
            }
        }
    }
</script>

<style scoped>

</style>
